<div class="h-100 bg-white pt-0 radius-1 mx-auto">
    <div class="border-t-3 w-100 brc-default-l2 radius-t-1"></div>
    <div class="card border-0 h-100">
        <div class="viewport-header" *ngIf="zoom || pageCount || multiSelect">
            <div class="multi-select-box" *ngIf="multiSelect">
                <input type="text" [(ngModel)]="multiSelectPageFrom" (keydown.enter)='multiSelectPages()' [placeholder]="translationManager.getTranslation('од')">
                <input type="text" [(ngModel)]="multiSelectPageTo" (keydown.enter)='multiSelectPages()' [placeholder]="translationManager.getTranslation('До')">
                <a href="javascript:;" [title]="translationManager.getTranslation('Селектуј више страница') " (click)="multiSelectPages()">
                    <i class="fas fa-check"></i>
                </a>
            </div>
            <div class="page-count-box" *ngIf="pageCount">
                <span>{{ translationManager.getTranslation('Број Страна:') }} {{numberOfPages}}</span>
            </div>
            <div class="zoom-box" *ngIf="zoom">
                <button (click)="zoomOut()">
                    <i class="fa fa-minus mr-2"></i>
                </button>
                <span>{{zoomScale + '%'}}</span>
                <button (click)="zoomIn()">
                    <i class="fa fa-plus mr-2"></i>
                </button>
            </div>
        </div>
        <div class="pdf-viewport" #pdfPages (scroll)="onScroll()">
            <div *ngFor="let item of items;let index = index;" class="pdf-element" [ngClass]="{show: !showSelectedPagesOnly || (showSelectedPagesOnly && item.selected) }">
                <div class="pdf-item-cont" [style.width]="zoomScale + '%'">
                    <div class="pdf-item" [ngClass]="{ selected: item.selected && selectable }" [style.cursor]="selectable && !item.disabled ? 'pointer' : 'default'" [style.background-image]="item.fileSource ? 'url(' + item.fileSource + ')' : 'unset'" (click)="selectable && !item.disabled && select(item)" [attr.page]="item.pageNumber" [attr.rendered]="item.rendered" [attr.in-container]="!showSelectedPagesOnly || (showSelectedPagesOnly && item.selected)">
                        <div class="pdf-item-disabled" *ngIf="item.disabled"></div>
                        <div class="pdf-page">
                            <span>{{index + 1}}.</span>
                        </div>
                        <!-- <img [src]="item.fileSource" style="width: 100%" /> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
